import { H4 } from "../../../AbstractElements";

export const ItemColumns = (ActionCell) => [
        {
            name: <i className="fa fa-gears" style={{ fontSize: '15px' }}></i>,
            selector: row => row.action,
            cell: row => <ActionCell row={row}/>,
            sortable: true,
            width: "50px"
        },
        {
            name: <H4>Images</H4>,
            selector: row => row.Image,
            sortable: true,
            width: '90px'
        },
        {
            name: <H4>Name</H4>,
            selector: row => row.Name,
            sortable: true,
            center: false,
            wrap: true,
            sortFunction: (a, b) => {
                const nameA = a?.Name?.toString().toLowerCase() || '';
                const nameB = b?.Name?.toString().toLowerCase() || '';
                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0;
            }
        },
        {
            name: <H4>Category</H4>,
            selector: row => row.Category,
            sortable: true,
            center: false,
            wrap: true,
            sortFunction: (a, b) => {
                const nameA = a?.Category?.toString().toLowerCase() || '';
                const nameB = b?.Category?.toString().toLowerCase() || '';
                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0;
            }
        },
        {
            name: <H4>Quantity</H4>,
            selector: row => row.Stock,
            sortable: true,
        },
        {
            name: <H4>Price</H4>,
            selector: row => parseFloat(
                row.Price
                    .replace(authState.currency, '')
                    .replace(/,/g, '')
                    .trim()
            ),
            cell: row => row.Price,
            sortable: true,
        },
        {
            name: <H4>Purchase Price</H4>,
            selector: row => parseFloat(
                row.Purchase_price
                    .replace(authState.currency, '')
                    .replace(/,/g, '')
                    .trim()
            ),
            cell: row => row.Purchase_price,
            sortable: true,
        },
        {
            name: <H4>Status</H4>,
            selector: row => row.Status,
            sortable: true,
        },
    ];